'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  return _react2.default.createElement('svg', {
    width: '14',
    height: '11',
    viewBox: '0 0 14 11'
  }, _react2.default.createElement('path', {
    d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0',
    fill: '#fff',
    fillRule: 'evenodd'
  }));
};